<template>
    <div id="counsellors-data-table">
        <div v-if="alert.status" :class="getAlertClass()" role="alert">
            <i :class="getAlertIcon()"></i> {{ alert.message }}
        </div>
        <div class="row mb-3">
            <div class="col-12 col-md-6">
                <h6 class="font-weight-bold">Counsellors Management</h6>
            </div>
            <div class="col-12 col-md-6 text-md-right">
                <counsellor-add @refreshData="refreshData"></counsellor-add>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm mb-0">
                <caption>List of counsellors ({{ counsellors.length }})</caption>
                <thead>
                    <tr>
                        <th scope="col">Last Name</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Waiting Area</th>
                        <th scope="col">Zoom Link</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(counsellor, i) in counsellors" :key="i">
                        <td>{{ counsellor.surname || "None" }}</td>
                        <td>{{ counsellor.givenName || "None" }}</td>
                        <td>{{ counsellor.waitingArea || "None" }}</td>
                        <td v-if="counsellor.zoomLink">
                            <a :href="counsellor.zoomLink" target="_blank">{{ counsellor.zoomLink }}</a>
                        </td>
                        <td v-else>
                            None
                        </td>
                        <td>
                            <counsellor-edit :counsellor="counsellor" :waitingAreas="waitingAreas"
                                @refreshData="refreshData"></counsellor-edit>
                            <counsellor-view :counsellor="counsellor"></counsellor-view>
                            <counsellor-delete :counsellor="counsellor" @refreshData="refreshData" @setAlert="setAlert">
                            </counsellor-delete>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="counsellors.length == 0" class="alert alert-primary" role="alert">
                <i class="fas fa-bell"></i> There are currently no counsellors. If you would like to add a
                counsellor, please click the 'add' button.
            </div>
        </div>
    </div>
</template>

<script>
import CounsellorAdd from './CounsellorAdd.vue';
import CounsellorDelete from './CounsellorDelete.vue';
import CounsellorEdit from './CounsellorEdit.vue';
import CounsellorView from './CounsellorView.vue';

export default {
    name: 'counsellors-data-table',
    components: {
        CounsellorAdd,
        CounsellorDelete,
        CounsellorEdit,
        CounsellorView
    },
    props: {
        counsellors: {
            required: true,
            type: Array
        },
        waitingAreas: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            }
        }
    },
    methods: {
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setAlert(message, status, type) {
            // Set alert
            this.alert = {
                message: message,
                status: status,
                type: type
            };

            // Set alert timeout
            setTimeout(() => {
                this.alert = {
                    message: '',
                    status: false,
                    type: ''
                }
            }, 5000);
        }
    }
}
</script>

<style>
.btn-action {
    width: 34px !important;
}
</style>